export const meddicTexts = {
  title: 'MEDDIC Methodology',
  description: `The MEDDIC methodology plugin seamlessly integrates essential fields into your environment, acting as checkpoints between stages you define for a structured qualification process. Already using MEDDIC fields? No worries! Our field mapper effortlessly aligns Sweep's fields with your existing ones, ensuring a smooth transition.`,
};
